<template>
  <q-skeleton type="rect" height="100px" v-if="loading || ordersLoading" />
  <div class="summary__details" v-if="!loading && !ordersLoading">
    <StatsCard
      v-for="item in statsItems"
      :key="item.id"
      :label="item.label"
      :value="item.value"
      :icon="item.icon"
      :color="item.color"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import StatsCard from './StatsCard.vue';

export default {
  name: 'SummaryCardStats',
  components: {
    StatsCard,
  },
  props: {
    event: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapState('dashboardCharts', ['totalViews']),
    ...mapState('dashboardEvents', [
      'ordersLoading',
      'loading',
      'totalPhotosInEvent',
    ]),
    statsItems() {
      if (!this.event.ordersSummary) {
        return [];
      }
      return [
        {
          id: 1,
          label: this.$t('dashboard.main.albumViews'),
          value: this.totalViews || 0,
          icon: 'visibility',
          color: '#ff69b4',
        },
        {
          id: 2,
          label: this.$t('dashboard.main.totalOrders'),
          value: this.event.ordersSummary.totalOrders || 0,
          icon: 'shopping_cart',
          color: '#5a67d8',
        },
        {
          id: 3,
          label: this.$t('dashboard.main.totalAlbumsSold'),
          value: this.event.ordersSummary.totalAlbumsSold || 0,
          icon: 'collections',
          color: '#3182ce',
        },
        {
          id: 4,
          label: this.$t('dashboard.main.totalPhotosInEvent'),
          value: `${this.totalPhotosInEvent}`,
          icon: 'photo',
          color: '#43a047',
        },
      ];
    },
  },
};
</script>

<style lang="scss" scoped>
.summary__details {
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  gap: 16px;
  width: 100%;
  margin-bottom: 12px;

  @media (min-width: $breakpoint-sm-min) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (min-width: $breakpoint-lg-min) {
    grid-template-columns: repeat(4, 1fr);
  }
}
</style>
